<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>

    <div class="container-fluid p-0">
      <div class="row widget-grid ">
        <bread_crumbs main="Snapshot Reports" :breadcrumbPath="breadcrumbPath" />
        <el-row class="m-0 width-100-p pl-2">
        <!-- Filter and Snapshot button -->
        <el-col :span="24">

          <!-- Filter component -->
          <div>
          <FilterS7
            :periodNameProp="'Current MP'"
            @filterHandle="snapshotFilterHandle" 
            @snapshotHandle="handleSnapshot"
            />
          </div>
        </el-col>
      </el-row>

      <el-row class="m-0 width-100-p mt-3">
        <el-col class="d-flex align-item-center px-2" :span="24">
          <div class="row m-0 width-100-p px-2">

            <div
              class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
            >
            <h5 class="text-white py-10 px-20">List of snapshots</h5>

            <!-- width > 700 -->
              <el-col class="mb-2" :span="24">
                <div class="row m-0">
                  <!-- width > 700 -->
                  <el-col
                    :span="$vuetify.display.width >= 1200 ? 12 : $vuetify.display.width >= 700 ? 14 : 24"
                    class="d-flex align-item-center"
                    :class="
                      $vuetify.display.width < 750
                        ? 'x-center mt-2 width-100-p'
                        : 'justify-start'"
                    >
                      <el-input
                        size="large"
                        v-model="filter.search"
                        placeholder="Type to search by user name ..."
                        :prefix-icon="Search"
                        class="mixedSearchBar-2"
                        id="mixedSearchBar-input-2"
                        clearable
                        @clear="handleReload()"
                      >
                        <template #append>
                          <el-button
                          @click.stop="handleReload()"
                          class="newSearchButtonClass"
                        >
                        <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                        </template>
                      </el-input>
      
                  </el-col>

                  <!-- time picker -->
                  <el-col
                    v-if="$vuetify.display.width < 700"
                    :span="24"
                    class="d-flex align-item-center"
                    >

                    <el-date-picker
                        v-model="filter.logDateTime"
                        type="date"
                        placeholder="Filter table by log date"
                        size="default"
                        class="w-100"
                        :class="$vuetify.display.width >= 375 ? 'width-200 mt-2' : ''"
                        format="DD/MM/YYYY"
                        date-format="DD/MM/YYYY"
                        value-format="YYYY-MM-DD"
                      />

                  </el-col>

                  <!-- width > 700 -->
                  <el-col
                    v-if="$vuetify.display.width >= 700"
                    :span="$vuetify.display.width >= 1200 ? 10 : 10"
                    class="d-flex align-item-center"
                    :class="
                      $vuetify.display.width < 750
                        ? 'x-center mt-2'
                        : 'justify-start'"
                    >

                      <el-date-picker
                        v-model="filter.logDateTime"
                        type="date"
                        placeholder="Filter table by log date"
                        size="default"
                        class="w-100"
                        :class="$vuetify.display.width >= 1200 ? 'width-400' : ''"
                        format="DD/MM/YYYY"
                        date-format="DD/MM/YYYY"
                        value-format="YYYY-MM-DD"
                      />


                  </el-col>



                </div>
              </el-col>

              <DataTable
                :loadingProp="loading"
                :usersDataProp="historyDataList"
                :totalRowProp="total_items"
                @tableAction="handleTableAction"
              />
            </div>
          </div>
        </el-col>
      </el-row>
      <ShowDetail
        :open_modal="show_modal"
        :data_modal="data_modal"
        :data_comment="data_comment"
        @close_modal="close_modal"
      />
      </div>
      



    </div>
</template>

<script>
import bread_crumbs from "@/components/bread_crumbs.vue";
import { createLoadingInstance } from "../common/common-tools";
// import XLSX from "xlsx";
import DataTable from "./dataTable.vue";

import {exportMultipleDataLists} from "../common/exportExcel.js";

import ShowDetail from "./dialogDetail.vue";
import userService from "@/services/user.service";

import FilterS7 from "../common/filter-s7.vue";

// import { ElMessageBox } from "element-plus";

import moment from 'moment-timezone';




export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: "snapshotReports",
    components: {

      ShowDetail,
      DataTable,
      bread_crumbs,

      // Filter,
      FilterS7,
  },

    data() {
      return {



        // for send snapshotRequest
        // step 5
        snapshotRequest: {
          start_date: null,
          end_date: null,
          report_type : null,
          current_page: null,
          perPageCount: null,
          no_page: true,
          search: null,
      },
      // for send snapshotRequest

        snapshotRes: null,

        breadcrumbPath: [
        {
          title: "General",
          disabled: true,
          href: "",
        },
        {
          title: "Snapshot Reports",
          disabled: false,
          href: "/dashboard-snaphot-reports",
          active: true,
        },
      ],

        show: true,
        historyDataList: [],
        originalHistoryDataList: [], // use for reset data
        current_page: 1,
        page_size: 50,
        total_items: 0,
        perPageCount: 50,
        loading: false,
        show_modal: false,
        data_modal: null,
        table_data: null,

        search: "",

        // comment for snapshot report data : send to child component dialogDetail.vue
        data_comment: null,

        current_row_index: null,
        filterOpen: false,


        filter: {
          fromDate: "",
          toDate: "",
          formKind: "",
          actionKind: "",
          search: "",

          logDateTime: "",
        },

        // snapshot request filter
        snapshotFilter: {
          // customer_id: null,
          startDate: null,
          endDate: null,
          search: null, // Search bar

        },


      };
    },
    watch: {
      'filter.logDateTime': function (newVal) {
        // console.log("logDateTime", newVal);
        if (newVal)
          this.filterHistoryData(newVal);
        else
          this.filterHistoryData("");

      },

      'current_page': function (newVal) {
        this.fetchHistoryData(newVal);
      },
    },
    computed: {
      filter_history() {
        return this.historyDataList;
      },

      // stateList to filter
      stateList() {
        return this.states;
    },

    },
    mounted() {
    // snapshot request
    // step 4
    // reset before_change data to empty for snapshot request
    this.snapshotRequest.before_change = [];
    // snapshot request

      this.fetchHistoryData(this.current_page);
    },
    methods: {


    // Handle filter snapshot log table by time picker; date or date and time
    filterHistoryData(date) {

      this.filter.fromDate = date;
      this.filter.toDate = date;
      this.fetchHistoryData(this.current_page);

    },

    /** convert response data from UTC to AU/SYD
     * Converts a given date string to a specified format in the 'Australia/Sydney' timezone.
     *
     * @param {string} dateString - The date string to be converted. Expected format: 'YYYY-MM-DDTHH:mm:ss.sssZ'.
     * @param {string} type - The type of format to return. Can be 'date', 'time', or 'date_time'.
     * @returns {string} - The formatted date string in the 'Australia/Sydney' timezone.
     *
     * Description:
     * - The function first cleans the input date string by removing any fractional seconds and appending 'Z' to indicate UTC time.
     * - It then creates a moment object in UTC and converts it to the 'Australia/Sydney' timezone.
     * - Depending on the 'type' parameter, the function returns the date in one of the following formats:
     *   - 'date': 'YYYY-MM-DD'
     *   - 'time': 'HH:mm:ss'
     *   - 'date_time': 'YYYY-MM-DD HH:mm:ss'
     */
    convertTimezone(dateString, type) {
        const cleanedDateString = dateString.split('.')[0] + 'Z';
        const date = moment.utc(cleanedDateString).tz('Australia/Sydney');
        if (type === 'date') {
          return date.format('YYYY-MM-DD');
        } else if (type === 'time') {
          return date.format('HH:mm:ss');
        }
        if (type === 'date_time') {
          return date.format('YYYY-MM-DD HH:mm:ss');
        }

    },


      /**
       * Handles the snapshot request process.
       *
       * Description:
       * - Displays an alert indicating that the snapshot request has been sent.
       * - Call function sendSnapshot to send request.
       * - Wait for response...
       *
       * - Response data (example):
       * {"task_id": "22cf4c04-2443-49dc-a6cd-f12005e01fb1",
          "status": "Task is running",
          "check_results": [
              {
                  "data_type": "user",
                  "type": "<class 'str'>",
                  "valid_json": true
              },]
          }
       * - Displays a summary message indicating the success or failure of each snapshot function.
       * - Refetch the history log list.
       */
      async handleSnapshot() {

        
        // ElMessageBox.alert(, { dangerouslyUseHTMLString: true, type: "success" }).then(()=> {const loading = createLoadingInstance("Taking snapshot..."); return loading;}).catch(()=>{return;});
        const loading = createLoadingInstance(`Taking snapshot...
        It may take a few minutes to complete.`);
        
        // Show a single alert message summarizing the results
        await this.sendSnapshot().then(
          () => {
            if(this.snapshotRes == undefined) {
              return;
            } else {
              console.log("snapshot done!");
              loading.close();
            // let results = this.snapshotRes;
            // // console.log("results", typeof(results));
            // const successEntries = results.filter(result => result.valid_json).map(result => ({ DataType: result.data_type, Status: "Success" }));
            // const failureEntries = results.filter(result => !result.valid_json).map(result => ({ DataType: result.data_type, Status: "Failure" }));
            // const summaryTable = [...successEntries, ...failureEntries];
            // console.table(summaryTable);
          }
          }
        ).catch((err)=>{
          console.log("error to get snapshot response", err.message
          );
          loading.close();
        }).finally(()=>{
          loading.close();
          console.log('fetch history data');
          this.fetchHistoryData(this.current_page);
        });
      },

      /**
       * Sends a snapshot request to the server.
       *
       * Example request:
       *  snapshotRequest: {
           start_date: null,
           end_date: null,
           report_type : null,
           current_page: null,
           perPageCount: null,
           no_page: true,
           search: null,
        },
       *
       * Description:
       * - Constructs a `snapshotRequest` object with start datetime and end datetime.
       * - Sets the current date and time as the `log_date`.
       * - Sends the snapshot request to the server
       * - Logs any errors that occur during the request.
       * - Save check_results from response data into snapshotRes
       */
      async sendSnapshot() {

          // const before_change = this.snapshotRequest.before_change;
          const snapshotRequest = this.snapshotRequest;

            try {

                const currentDate = new Date().toISOString();
                snapshotRequest.log_date = currentDate;

                this.snapshotRes = null; // reset snapshotResopnse data before end new request

                await userService.newSnapshotRequest(snapshotRequest, 1, 50, true ).then(
                  (snapshotRes) => {
                    const check_results = snapshotRes.data.check_results;
                    // console.log("snapshotRes", check_results);
                    this.snapshotRes = check_results;
                  }
                ).catch((err)=>{
                  console.log("error when running snapshot request", err.message);
                  return;

                });
                } catch (error) {
                  console.error("Error when sending snapshot request", error.message);
                  return;
              }

          },
          // handle snapshot button

      // snapshot filter handle
      snapshotFilterHandle(event) {
        this.snapshotFilter = event;
        this.handleApplySnapshotFilterData();
      },

      handleApplySnapshotFilterData() {

        // update request data with filter data
        this.snapshotRequest.start_date = this.snapshotFilter.startDate;
        this.snapshotRequest.end_date = this.snapshotFilter.endDate;
        this.snapshotRequest.search = this.snapshotFilter.search;
      },

      // fetch history data
      /**
       * Fetches the history data for snapshots.
       *
       * @param {number} page - The page number to retrieve.
       *
       * Response example: {
            "code": 1000,
            "message": "get History Log successfully.",
            "history_logs": [
                {
                    "id": 602,  >>> used to fetch history log tables data for select row
                    "log_date": "2025-04-02T00:13:20",
                    "form_kind": "report_snapshot",
                    "action_kind": "create_snapshot",
                    "document_id": "report_snapshot",
                    "comment": "snapshot of the reports",
                    "user_id": 1,
                    "user_full_name": "Asdasd Asdsd",
                    "user_email": "asdasd@gmail.com",
                    "created_at": "2025-04-02T00:13:20.760541",
                    "updated_at": "2025-04-02T00:13:20.765380"
                },
       *
       * Description:
       * - Calls the `getSnapshotList` method from the `userService` with the provided page number, filter, and per page count.
       * - Processes the response to filter and update the `historyDataList` with items that have `form_kind` as "report_snapshot" and `action_kind` as "create_snapshot".
       * - Updates the `total_items` with the total record count from the response.
       * - Handles errors by logging them and redirecting to the home page if the error status is 401 (Unauthorized).
       * - Ensures that the loading state is set to false after the request is completed.
       */
      fetchHistoryData(page) {
        // this.filter.search = this.search;
        userService.getSnapshotList(page, this.filter, this.perPageCount)
          .then(
            (response) => {
              const dataList = response.data.history_logs;

              if(dataList && dataList.length > 0) {
                this.historyDataList = dataList.filter((item) => item.form_kind === "report_snapshot" && item.action_kind === "create_snapshot");
                this.originalHistoryDataList = [...this.historyDataList];
              } else {
                this.historyDataList = [];
                this.originalHistoryDataList = [];
              }

              this.total_items = response.data.total_record;

            },
            (error) => {
              this.loading = false;
              console.log(error);
              if (error.response.status == 401) {
                this.$router.push({
                  path: "/",
                });
              }
            }
          )
          .catch((error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          })
          .finally(() => (this.loading = false));
      },

      /**
       * fetch selected history log data by log id
       * Send id from selected row of history log, get table lists of all table data in response
       *
       * request: {
            "id": 634
        }

       * response: {
            "code": 1000,
            "message": "get History Log successfully.",
            "newList": [
                {
                    "user": [{}],
                    "client_tota" : [{}],
                      ...
                    "all_charging_sites": [{}],
              }
      */
      async fetchTableDataByID(logID) {
        let request = {
          id: logID,
        }
        await userService.getSnapshotById(request)
          .then(
            (response) => {
              if(response.status == 200 && response.data) {
                // console.log(response.data.newList[0]);
                this.table_data = response.data.newList[0];
              }
            },
            (error) => {
              this.loading = false;
              console.log(error);
              if (error.response.status == 401) {
                this.$router.push({
                  path: "/",
                });
              }
            }
      ).then(
        () => {

          this.groupTable();
        }
      ).catch((error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          })
          .finally(() => (this.loading = false));
      },


      /**
       * Exports the snapshot data to an Excel file.
       *
       * @param {number} index - The index of the current row.
       * @param {Object} data - The data object containing the snapshot details.
       *
       * Description:
       * - get all table data by history log  id:
       *        * request: {
                  "id": 634
              }

            * response: {
                  "code": 1000,
                  "message": "get History Log successfully.",
                  "newList": [
                      {
                          "user": [{}],
                          "client_tota" : [{}],
                            ...
                          "all_charging_sites": [{}],
                    }

       * - Sets the `current_row_index` to the provided index.
       * - Creates a new workbook using `XLSX.utils.book_new()`.
       * - Iterates over the parsed `fileData` and appends each table's data as a separate sheet in the workbook.
       * - Writes the workbook to an Excel file with the specified file name.
       */
      // handleExportFile(index, data) {
      //   if (data.id != null && data.id != "") {

      //     this.current_row_index = index;

      //     const fileName = data.comment;

      //     this.fetchTableDataByID(data.id).then(
      //         () => {
      //           this.groupTable();
      //         }
      //       ).then(
      //         () => {
      //           const fileData = this.data_modal;
      //           console.log("fileData", fileData);

      //           const wb = XLSX.utils.book_new();

      //           fileData.forEach((item) => {

      //             for (const table of item.data) {
      //               const ws = XLSX.utils.json_to_sheet(table.data);
      //               XLSX.utils.book_append_sheet(wb, ws, (table.table_name).replace("by_state_and_region_and_charger_type", "byStateAndRegionAndChargerType"));
      //             // if sheet name exceeds 31 characters replace it with shorter name
      //           }
      //           });

      //           XLSX.writeFileXLSX(wb, `${fileName}.xlsx`);
      //         }
      //       );


      //   }
      // },

      handleExportFile(index, data) {
        if (data.id != null && data.id !== "") {
          this.current_row_index = index;

          this.fetchTableDataByID(data.id).then(() => {
            this.groupTable();
          }).then(async () => {
            const fileData = this.data_modal;
            // console.log("fileData", fileData);

            const tableData = {};
            const tableNames = {};
            const skipKeysList = {};

            fileData.forEach((item) => {
              for (const table of item.data) {
                tableData[table.table_name] = table.data;

                let shortName = table.table_name.replace(
                  "by_state_and_region_and_charger_type",
                  "byStateAndRegionAndChargerType"
                );

                if (shortName.length > 31) {
                  shortName = shortName.slice(0, 28) + "...";
                }

                tableNames[table.table_name] = shortName;
              }
            });

            // console.log("tableData", tableData);
            // console.log("name", tableNames);

            try {
                    await exportMultipleDataLists({
                        title: "snapshot Report",
                        tableData,
                        tableNames,
                        skipKeysList,
                        fileName: "SnapshotReport.xlsx",
                        });
                        console.log("Excel file generated successfully!");
                } catch (error) {
                    console.error("Error generating Excel file:", error);
                }


          });
        }
      },

      reset_filter11(event) {
        this.current_page = 1;
        this.search = "";
        this.filter = event.filter;
        this.fetchHistoryData(this.current_page);
      },

      handleTableAction(event) {
        if (event.kind == "edit") {
          this.handleShow(event.index, event.data);
        } else if (event.kind == "export") {
          this.handleExportFile(event.index, event.data);
        } else if (event.kind == "delete") {
          this.deleteRow(event.data, event.index);
        } else if (event.kind == "changePage") {
          this.current_page = event.index;
          // this.fetchHistoryData(this.current_page);
        } else if (event.kind == "perPageChange") {
          this.current_page = 1;
          this.perPageCount = event.index;
          this.handleReload();
        }
      },

      handleReload() {
        // this.filter.search = event.filter.search;
        // this.filter = event.filter;
        this.fetchHistoryData(this.current_page);
      },



      filterSearch11(event) {
        this.filter.search = event.search;
        this.fetchHistoryData(this.current_page);
      },


      /**
       * Organize data into grouped structure before send to child detail popup table
       * after group up save table list to this.data_modal
       *
       * Grouped into charger_tables:  all_chargers, all_charging_sites, charger_ports
       *
       * Grouped into verra_report: project_instance, verra_eq1, verra_eq4, verra_eq5, verra_eq7, verra_eq9
       *
       * Grouped into auditor_report: client_total, full_breakdown, by_state_and_region, by_state_and_region_and_charger_type, private_fleet_by_site, by_state_and_region_1, by_state_and_region_2, sd_vista
       *
       * Grouped into baseline_params: baseline_params, site_baseline_params
       * */
      groupTable() {

        let data = this.table_data;
                let tableList = [];

                tableList = [

                {
                  table_name: "auditor_report",
                  data: [
                    {
                      table_name: "client_total",
                      data: data.client_total || []
                    },
                    {
                      table_name: "full_breakdown",
                      data: data.full_breakdown || []
                    },
                    {
                      table_name: "by_state_and_region",
                      data: data.by_state_and_region || []
                    },
                    {
                      table_name: "by_state_and_region_and_charger_type",
                      data: data.by_state_and_region_and_charger_type || []
                    },
                    {
                      table_name: "private_fleet_by_site",
                      data: data.private_fleet_by_site || []
                    },
                    {
                      table_name: "by_state_and_region_1",
                      data: data.by_state_and_region_1 || []
                    },
                    {
                      table_name: "by_state_and_region_2",
                      data: data.by_state_and_region_2 || []
                    },
                    {
                      table_name: "sd_vista",
                      data: data.sd_vista || []
                    }
                ]
              },

              {
                  table_name: "verra_report",
                  data: [
                    {
                      table_name: "project_instance",
                      data: data.project_instance_result_json || []
                    },
                    {
                      table_name: "verra_eq1",
                      data: data.verra_eq1 || []
                    },
                    {
                      table_name: "verra_eq4",
                      data: data.verra_eq4 || []
                    },
                    {
                      table_name: "verra_eq5",
                      data: data.verra_eq5 || []
                    },
                    {
                      table_name: "verra_eq7",
                      data: data.verra_eq7 || []
                    },
                    {
                      table_name: "verra_eq9",
                      data: data.verra_eq9 || []
                    },
                ]
              },

                {
                  table_name: "user_table",
                  data: [
                    {
                      table_name: "user_table",
                      data: data.user || []
                    },
                  ]
                },

                {
                  table_name: "baseline_params",
                  data: [
                    {
                      table_name: "baseline_params",
                      data: data.baseline_params || []
                    },
                    {
                      table_name: "site_baseline_params",
                      data: data.site_baseline_params || []
                    },
                  ]
                },


                {
                  table_name: "battery_intensities",
                  data: [
                    {
                      table_name: "battery_intensities",
                      data: data.battery_intensities || []
                    },
                  ]
                },

                {
                  table_name: "monitoring_periods",
                  data: [
                    {
                      table_name: "monitoring_periods",
                      data: data.monitoring_periods || []
                    },
                  ]
                },

                {
                  table_name: "charger_tables",
                  data: [
                    {
                      table_name: "all_chargers",
                      data: data.all_chargers || []
                    },
                    {
                      table_name: "all_charging_sites",
                      data: data.all_charging_sites || []
                    },
                    {
                      table_name: "charger_ports",
                      data: data.charger_ports || []
                    },
                  ]
                },

              ]
                // console.log("data", data);
                // console.log("tableList", tableList);
                this.data_modal = tableList;

      },


      handleShow(index, data) {
        try {
          // console.log(" send to data", data);

          // console.log("click on row data", index, data);

          if (data.id != null && data.id != "") {

            this.current_row_index = index;
            // get comment data for the row
            this.data_comment = data.comment;
            // send row data to popup window

            this.fetchTableDataByID(data.id).then(
              () => {
                this.groupTable();
              }
            ).then(
              () => {
                this.show_modal = true;
              }
            );
          }
        } catch (error) {
          console.error("Error when showing detail, if get error message: expected property name or '}', check data if in json format", error);
        }



      },
      // eslint-disable-next-line no-unused-vars
      close_modal(event) {
        this.show_modal = false;
      },
    },
  };
</script>

<style scoped>
  .el-table .warning-row {
    --el-table-tr-bg-color: var(--el-color-warning-light-8);
  }
  .el-table .error-row {
    --el-table-tr-bg-color: var(--el-color-error-light-8);
  }

  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }

  .cell {
    text-align: center !important;
  }

  .starter-main .card-body ul {
    list-style-type: none !important;
  }

  .el-pager {
    -webkit-user-select: none !important;
    user-select: none !important;
    list-style: none !important;
    font-size: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    display: flex !important;
    align-items: center !important;
    position: relative !important;
    top: 0 !important;
    right: 0 !important;
  }

  .el-upload-list {
    margin: 10px 0 0 !important;
    padding: 0 !important;
    list-style: none !important;
    position: relative !important;
  }
</style>
